export const bidderSettings = {
    storageAllowed: true,
};
